import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly _toastMessage$ = new BehaviorSubject<any>({});

  readonly toastMessage$ = this._toastMessage$.asObservable();

  public show(
    message: string,
    variant: 'error' | 'info' | 'success' | 'warning',
    translate?: boolean,
    duration = 5000
  ): void {
    this._toastMessage$.next({
      message,
      variant,
      translate,
      duration,
    });
  }

  public toastMessageValue(): any {
    return this._toastMessage$.getValue();
  }
}
